var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSearchBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.7L12.11 10.81C14.11 8.17 13.92 4.38 11.51 1.97C8.88 -0.660002 4.6 -0.660002 1.97 1.97C-0.660002 4.6 -0.660002 8.88 1.97 11.51C3.28 12.82 5.01 13.48 6.74 13.48C8.18 13.48 9.61 13.02 10.81 12.11L14.7 16L16 14.7ZM3.27 10.21C1.36 8.3 1.36 5.19 3.27 3.27C4.23 2.31 5.48 1.84 6.74 1.84C8 1.84 9.25 2.32 10.21 3.27C12.12 5.18 12.12 8.29 10.21 10.21C8.3 12.12 5.19 12.12 3.27 10.21V10.21Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchBlack);
export default __webpack_public_path__ + "static/media/ic_searchBlack.288f65bca787d3ee74ccd11f15a0a245.svg";
export { ForwardRef as ReactComponent };